import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

export type FixtureSegment = components["schemas"]["FixtureSegmentOut"];
export type FixtureVisit = components["schemas"]["FixtureVisitOut"];
type FixtureManifest = components["schemas"]["FixtureManifestOut"];

/** 404s unless backend `ENABLE_DEV_FIXTURES`; segment URLs are short-TTL presigned GETs. */
export async function fetchFixtures(): Promise<FixtureManifest> {
  return request(() => apiClient.GET("/dev/fixtures"));
}

export async function fetchSegmentAudio(url: string): Promise<ArrayBuffer> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Fixture fetch failed: ${res.status}`);
  return res.arrayBuffer();
}

/** Room-scope token so the WS streams as the room's device; refresh token discarded since reconnect re-calls this. */
export async function mintRoomWsToken(roomUuid: string): Promise<string> {
  const pair = await request(() =>
    apiClient.POST("/auth/select-room", { body: { room_uuid: roomUuid } }),
  );
  return pair.access_token;
}
